module.exports = __webpack_public_path__ + "static/media/logo@2x.7ffb7d1e.png";